export default {
  checkListData: [],
  checkListDates: [],
  checkListCriteria: [],
  dataIsGetted: false,
  idSelectedModule: 0,
  error: false,
  errorMessage: ''
}